var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageBoxOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 6.06527L9.99997 10.0005M9.99997 10.0005L2.91664 6.06527M9.99997 10.0005L10 17.9171M17.5 13.3826V6.61835C17.5 6.33281 17.5 6.19004 17.4579 6.06271C17.4207 5.95007 17.3599 5.84666 17.2795 5.75942C17.1886 5.66081 17.0638 5.59147 16.8142 5.4528L10.6475 2.02688C10.4112 1.89558 10.293 1.82993 10.1679 1.80419C10.0571 1.78141 9.94288 1.78141 9.83213 1.80419C9.70698 1.82993 9.58881 1.89558 9.35248 2.02688L3.18581 5.45281C2.93621 5.59148 2.8114 5.66081 2.72053 5.75942C2.64013 5.84667 2.57929 5.95007 2.54207 6.06271C2.5 6.19005 2.5 6.33281 2.5 6.61835V13.3826C2.5 13.6681 2.5 13.8109 2.54207 13.9382C2.57929 14.0509 2.64013 14.1543 2.72053 14.2415C2.8114 14.3401 2.93621 14.4095 3.18581 14.5481L9.35248 17.9741C9.58881 18.1054 9.70698 18.171 9.83213 18.1968C9.94288 18.2195 10.0571 18.2195 10.1679 18.1968C10.293 18.171 10.4112 18.1054 10.6475 17.9741L16.8142 14.5481C17.0638 14.4095 17.1886 14.3401 17.2795 14.2415C17.3599 14.1543 17.4207 14.0509 17.4579 13.9382C17.5 13.8109 17.5 13.6681 17.5 13.3826Z",
    stroke: "#F37721",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.91667L6.25 3.75",
    stroke: "#F37721",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageBoxOrange);
export default __webpack_public_path__ + "static/media/package-box-orange.ccfb3479da88ffcf9b83e3d5d2e50b72.svg";
export { ForwardRef as ReactComponent };